<template>
  <div class="guidelines">
    <div class="head row align-center column-s">
      <h1>Orientações</h1>
      &nbsp;&nbsp;&nbsp;
    </div>
    <div class="list">
      <div v-if="loader" class="column align-center justify-center">
        <Loader layout="small" />
      </div>
      <template v-else>
        <section class="row align-center column-s">
          <i class="fa fa-user" />&nbsp;CLIENTES &nbsp;
          <Button
            :layout="showForm ? 'red-go' : 'green-go'"
            title="NOVA ORIENTAÇÃO"
            @click="showForm = !showForm"
            >{{ showForm ? "x" : "+" }}</Button
          >
          <transition name="slide">
            <div
              v-if="showForm"
              class="new row grid-10 grid-12-s justify-center-s"
            >
              <GuidelineForm :form="form" />
            </div>
          </transition>
        </section>
        <br /><br />
        <input class="input search" v-model="search" placeholder="Pesquisar" />

        <div class="head row justify-space">
          <div class="grid-2">Nome</div>
          <div class="grid-2">Cliente</div>
          <div class="grid-2">Situação</div>
          <div class="grid-2">Criado</div>
          <div class="grid-2">Alterado</div>
        </div>
        <div class="content">
          <div v-for="(item, i) of filtered" :key="'item' + i">
            <div class="line row justify-space" @click="toggle(i)">
              <div class="grid-2">{{ item.nome }}</div>
              <div class="grid-2">{{ item.nome_cliente }}</div>
              <div class="grid-2">{{ item.status }}</div>
              <div class="grid-2">{{ item.criado_em | date }}</div>
              <div class="grid-2">{{ item.alterado_em | date }}</div>
            </div>
            <div v-if="item.show" class="edit row wrap column-s">
              <GuidelineForm :form="item" />
            </div>
          </div>
        </div>
      </template>
    </div>

    <div class="list">
      <div v-if="loaderDefault" class="column align-center justify-center">
        <Loader layout="small" />
      </div>
      <template v-else>
        <section><i class="fa-regular fa-file-lines" />&nbsp; PADRÃO</section>
        <section>Dados para Atendimento Presencial</section>
        <div class="column grid-11">
          <label>Requerimentos para Atendimento Presencial</label>
          <input v-model="formDefault.requerimento_presencial" type="text" />
        </div>
        <div class="column grid-11">
          <label>Orientações para Atendimento Presencial</label>
          <input v-model="formDefault.orientacao_presencial" type="text" />
        </div>
        <div class="column grid-11">
          <label>RAT para Atendimento Presencial</label>
          <input v-model="formDefault.rat_presencial" type="text" />
        </div>
        <section>Dados para Atendimento Remoto</section>
        <div class="column grid-11">
          <label>Requerimentos para Atendimento Presencial</label>
          <input v-model="formDefault.requerimento_remoto" type="text" />
        </div>
        <div class="column grid-11">
          <label>Orientações para Atendimento Presencial</label>
          <input v-model="formDefault.orientacao_remoto" type="text" />
        </div>
        <div class="column grid-11">
          <label>RAT para Atendimento Presencial</label>
          <input v-model="formDefault.rat_remoto" type="text" />
        </div>

        <div
          v-if="formDefault.nome_criado_por"
          class="info row wrap column-s justify-around"
        >
          <div class="text-center grid-5 g12-s">
            <label>Criado por</label>
            <div>
              {{ formDefault.nome_criado_por }} em {{ formDefault.criado_em | date }}
            </div>
          </div>
          <div class="text-center grid-5 g12-s" v-if="formDefault.nome_alterado_por">
            <label>Alterado por</label>
            <div>
              {{ formDefault.nome_alterado_por }} em {{ formDefault.alterado_em | date }}
            </div>
          </div>
        </div>
        <div class="text-center">
          <br /><br /><Button layout="green-go" @click="updateDefault">ATUALIZAR</Button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Button from "@/components/Button.vue";
import Loader from "@/components/Loader.vue";
import GuidelineForm from "@/views/admin/components/GuidelineForm.vue";

export default {
  name: "Guidelines",
  components: {
    Button,
    Loader,
    GuidelineForm,
  },
  data() {
    return {
      loader: false,
      loaderDefault: false,
      showForm: false,
      search: "",
      list: [],
      form: { send: this.send },
      formDefault: {},
    };
  },
  methods: {
    ...mapActions("admin", [
      "GUIDELINES_LIST",
      "GUIDELINES_UPDATE",
      "GUIDELINES_DEL",
      "GUIDELINES_NEW",
      "ORIENTATION_SUPPORTER_GET",
      "ORIENTATION_SUPPORTER_UPDATE",
    ]),
    async load() {
      this.loader = true;
      await this.GUIDELINES_LIST({})
        .then(({ data }) => (this.list = data || []))
        .catch(() => (this.loader = false));
      this.form = { send: this.send };
      this.loader = false;
    },
    async loadDefault() {
      this.loaderDefault = true;
      await this.ORIENTATION_SUPPORTER_GET().then(
        ({ data }) => (this.formDefault = data)
      );
      this.loaderDefault = false;
    },
    del(item) {
      if (confirm(`Deseja excluir ${item.nome}?`)) {
        return this.GUIDELINES_DEL(item).then(() => this.load());
      }
    },
    update(item) {
      this.GUIDELINES_UPDATE(item).then(({ status }) => {
        if (status == 200) this.load();
      });
    },
    async updateDefault() {
      this.loaderDefault = true;
      await this.ORIENTATION_SUPPORTER_UPDATE(this.formDefault).then(({ status }) => {
        if (status == 200) this.loadDefault();
      });
      this.loaderDefault = false;
    },
    async send(form) {
      return this.GUIDELINES_NEW(form).then(() => this.load());
    },
    async toggle(index) {
      this.list[index].show = !this.list[index].show;
      if (this.list[index].show) {
        this.list[index].update = true;
        this.list[index].send = () => this.update(this.list[index]);
        this.list[index].del = () => this.del(this.list[index]);
      }
      this.list = [...this.list];
    },
  },
  mounted() {
    this.$parent.$children[0].changeMenu("guidelines");
    this.load();
    this.loadDefault();
  },
  computed: {
    filtered() {
      if (this.search) {
        const search = this.search.toLowerCase();

        return this.list.filter((part) => {
          let partsSerialize = JSON.stringify(part).toLowerCase();
          return partsSerialize.includes(search);
        });
      } else {
        return this.list;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.guidelines
  @include page
  .list
    padding: 0 30px
    padding-bottom: 80px
  .new
    margin-left: 30px
  label, section
    margin-top: 31px
</style>
